import { userService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    countData: {
        authPendingUsers: 0,
        PendingBankGateways: 0,
        PendingPaymanGateways: 0,
        PendingIVRGateways: 0,
        PendingDedicatedGateways: 0,
        PendingCollectiveGateways: 0,
        PendingTicketsWithManageAccess: 0,
        PendingCardToCardGateways: 0,
        otherGateways: 0,
        creatadShaparakRequest: 0,
        EndedOnlineContracts: 0,
    },
    userOpenTicketsNo : 0
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, countData) {
        state.status = 'success',
        state.countData = countData
    },
    openUserTicketsNo(state, userOpenTicketsNo) {
        state.status = 'successCount',
        state.userOpenTicketsNo = userOpenTicketsNo
    }
}

const getters = {
    status: ({status}) => status,
    countData: ({countData}) => countData,
    openUserTicketsNo: ({userOpenTicketsNo}) => userOpenTicketsNo,
}

const actions = {
    countData({commit}, is_starshop = false) {
        commit('loading')
        return userService.countData(is_starshop).then(response => {
            commit('success', response.data.data)
        })
    },
    countUserTickets({commit}, hashid) {
        commit('loading')
        return userService.countOpenUserTickets(hashid).then(response => {
            commit('openUserTicketsNo', response.data.data)
        })
    }
}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}